import { createStore } from 'vuex'
import auth from './modules/auth'
import admin from './modules/admin'
import classModule from './modules/class'
import files from './modules/files'
import document from './modules/document'
import downloadTasks from './modules/downloadTasks'
import tabs from './modules/tabs'
import parentAuth from './modules/parentAuth'
import tasks from './modules/tasks'
import { saveTabs, getCurrentUserId } from '@/utils/tabs'

const tabsPersistPlugin = (store) => {
  store.subscribe((mutation, state) => {
    if (mutation.type.startsWith('tabs/') && mutation.type !== 'tabs/HYDRATE') {
      saveTabs(getCurrentUserId(), {
        visitedTabs: state.tabs.visitedTabs,
        activeKey: state.tabs.activeKey
      })
    }
  })
}

export default createStore({
  modules: {
    auth,
    admin,
    class: classModule,
    files,
    document,
    downloadTasks,
    tabs,
    parentAuth,
    tasks
  },
  plugins: [tabsPersistPlugin]
})